<div mat-dialog-title class="dialog-title">
  <h2>Select Question Type</h2>
  <button mat-icon-button title="Close Dialog" class="mat-dialog-title__close" (click)="onClose()">
    <fa-icon [icon]="faClose"></fa-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography">
  <div class="type-picker-layout">
    <div class="left-side-column">
      <div class="side-content">
        <button mat-list-item class="question-library__button" [class.active]="selectedType$() === 'vault'" (click)="selectedType$.set('vault')">
          <fa-icon [icon]="faBookmark"></fa-icon>
          <div class="item-text">
            <span class="text fs__sm fw__500">From Library</span>
            <span class="sub-text fs__xs">Stored questions</span>
          </div>
        </button>
        <mat-action-list>
          @for (typeSettings of questionTypeConfig | keyvalue: originalOrder; track typeSettings.key) {
            @if (typeSettings.value.active) {
              <button
                mat-list-item
                class="question-type__button"
                [class.active]="typeSettings.value.type === selectedType$()"
                (click)="selectedType$.set(typeSettings.value.type)"
              >
                <fa-icon [icon]="typeSettings.value.icon"></fa-icon>
                <div class="item-text">
                  <span class="text fs__sm fw__500">{{ typeSettings.value.text }}</span>
                  <span class="sub-text fs__xs">{{ typeSettings.value.subText }}</span>
                </div>
              </button>
            }
          }
        </mat-action-list>
      </div>
    </div>
    <div class="main-column">
      @if (selectedType$() === 'vault') {
        <div class="main-column-content">
          <empathy-question-library (selectedQuestions)="selectedFromLibrary$.set($event)"></empathy-question-library>
        </div>
        <div class="main-column-actions">
          <button mat-flat-button [color]="'primary'" [disabled]="selectedFromLibrary$().length === 0" (click)="onAddFromLibrary()">Add Question/s</button>
        </div>
      } @else {
        <div class="main-column-content">
          <div class="question-type__description">
            <ng-container *ngComponentOutlet="selectedTypeConfig$().descriptionComponent"></ng-container>
          </div>
          <div class="question-type__thumbnail">
            @if (selectedTypeConfig$().video) {
              <empathy-question-type-video [videoUrl]="selectedTypeConfig$().video"></empathy-question-type-video>
            } @else if (selectedTypeConfig$().thumbnail) {
              <img [src]="selectedTypeConfig$().thumbnail" />
            }
          </div>
        </div>
        <div class="main-column-actions">
          <button mat-flat-button [color]="'primary'" [mat-dialog-close]="selectedType$()">Add Element</button>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>
